export default __webpack_public_path__ + "static/media/bg_gradi_left01.24542040.png";